// eslint-disable-next-line monorepo/no-internal-import
import {useCampaignKey} from '@aboutyou/logic-components/src/backend-services/Campaigns/campaign-state/campaign.hooks';
import {useGlobalFetchTokenState} from '../../global-basket-wishlist-refetch-tokens';

export const useGlobalWishlistRefetchToken = () => {
  const campaignKey = useCampaignKey();
  const wishlistRefetchToken = useGlobalFetchTokenState(
    state => state.wishlistToken,
  );

  return campaignKey ? `${wishlistRefetchToken}-${campaignKey}` : undefined;
};
